module.exports = __webpack_public_path__ + "img/checkbox-marked.381c4fbc.svg";